import React from 'react';
import { Form, Popover, OverlayTrigger } from 'react-bootstrap';
import { Edit, AlertTriangle } from 'lucide-react';
import Checkbox from 'components/shared/StandaloneCheckbox';

export default class ProjectFeatureListItem extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            isChecked: props.isChecked,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        const value = e.target.checked;
        this.setState({
            isChecked: value
        });

        this.props.onCheckFeature(this.props.driverFeature.name, value);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isChecked !== prevState.isChecked) {
            this.setState({ isChecked: this.props.isChecked });
        }
    }

    render() {

        let label = `${this.props.driverFeature.displayName}`;

        let issueComponent = null;
        if (this.props.errors && this.props.errors.length > 0) {

            let errors = [];
            this.props.errors.forEach(error => {
                if (error.name && errors.indexOf(error.name) === -1) {
                    errors.push(error.name + ': ' + error.description);
                }
            });

            if (errors.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Errors</Popover.Title>
                        <Popover.Content>
                            {errors.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <AlertTriangle style={{ margin: 'auto', color: '#dc3545' }} />
                    </OverlayTrigger>
                );
            }
        }

        if (issueComponent === null && this.props.warnings && this.props.warnings.length > 0) {

            let warnings = [];
            this.props.warnings.forEach(warning => {
                if (warning.name && warnings.indexOf(warning.name) === -1) {
                    warnings.push(warning.name + ': ' + warning.description);
                }
            });

            if (warnings.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover" >Warnings</Popover.Title>
                        <Popover.Content>
                            {warnings.join(", ")}
                        </Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <AlertTriangle style={{ margin: 'auto', color: '#f0ad4e' }} />
                    </OverlayTrigger>
                );
            }
        }

        const edited = this.props.edit ? <Edit /> : null;

        const classNameDiv = this.props.isSelected ? 'div-project-feature-listitem-selected' : 'div-project-feature-listitem';
        const classNameSwitch = this.props.isSelected ? 'switch-project-feature-listitem-selected' : 'switch-project-feature-listitem';
        const classNameGroup = this.props.isSelected ? 'form-project-feature-listitem-selected' : 'form-project-feature-listitem';

        return (
            <div className={classNameDiv} >
                <Checkbox
                    style={{ fontSize: '0.25rem' }}
                    onChange={this.handleChange}
                    checked={this.state.isChecked}
                    id={`${this.props.driverFeature.id}`}
                    className={classNameSwitch}
                />
                <Form.Group
                    className={classNameGroup}
                    style={{ display: 'flex', cursor: 'default' }}
                    onClick={(e) => this.props.onShowFeature(e, this.props.driverFeature)} >

                    {label}
                    {issueComponent}
                    {edited}
                </Form.Group>

            </div>
        );
    }
}
